import { defaultSettings } from "src/common/settings"

// ----------------------------------------------------------------------

export const schemeConfig = {
    modeStorageKey: "theme-modes",
    defaultMode: defaultSettings.colorScheme,
}
